import styled from 'styled-components'

import { breakpoints } from '@awazevr/design-system.utils.react'

export const ExplorationContainer = styled.section`
  margin-bottom: 1.5rem;
  background: color-mix(
    in srgb,
    ${({ theme }) => theme.ColorBrandPrimary} 15%,
    transparent
  );

  /* Mobile: full-bleed to the device edges (relies on the centred flex parent). */
  width: 100vw;
  padding: 1.25rem 0;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    width: 100%;
    border-radius: 12px;
  }
`

export const ExplorationHeading = styled.h2`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.FontTextText400MidFontWeight};
  color: ${({ theme }) => theme.ColorTextBodyOnLight};
  margin: 0 0 0.75rem 0;
  padding-left: ${({ theme }) => theme.GridBaseGridSmall0GutterSize}px;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    padding-left: 1.25rem;
  }
`

export const ExplorationTrack = styled.div<{ $ready: boolean }>`
  /* No overflow clip here on purpose — Swiper clips internally; an extra clip
     around the animating wrapper defeats GPU compositing and causes jank. */
  opacity: ${({ $ready }) => ($ready ? 1 : 0)};
  transition: opacity 150ms ease;

  .swiper-slide {
    width: 238px;
    height: auto;
  }
`

export const ExplorationLink = styled.a`
  display: flex;
  flex-direction: column;
  width: 238px;
  flex-shrink: 0;
  text-decoration: none;
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  color: ${({ theme }) => theme.ColorTextBodyOnLight};
  user-select: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.ColorThemeLink};
    outline-offset: 2px;
  }
`

export const ExplorationImage = styled.img`
  width: 100%;
  height: 118px;
  object-fit: cover;
  display: block;
  user-select: none;
  -webkit-user-drag: none;

  @media only screen and (min-width: ${breakpoints[1]}px) {
    height: 124px;
  }
`

export const ExplorationLabel = styled.span`
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  font-weight: 700;
`
